import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class InterfaceService {
  displayDark = true;
  footerBackgroundChange = true;

  isMenuOpen = false;
  startDisplay = false;
  startSidebarDisplay = false;
  isOpacityActivated = false;
  isSidebarOpacityActivated = false;
  isBlurActivated = false;
  isSidebarOpen = false;
  isLightboxOpen = false;

  firstLoad = false;
  languageChanged = false;
  resetArtworks = false;

  displayForm = false;
  displaySuccess = false;
  currentForm = null;

  isVideoPlayerOpen = false;

  constructor(private dataService: DataService) {}

  toggleSidebar() {
    if (!this.startSidebarDisplay) {
      this.startSidebarDisplay = true;
      this.isSidebarOpacityActivated = true;
      this.isSidebarOpen = true;
    } else {
      this.isSidebarOpen = false;
      this.isSidebarOpacityActivated = false;
      this.closeSidebar();
    }
  }

  closeSidebar() {
    let that = this;

    setTimeout(function () {
      that.startSidebarDisplay = false;
    }, 500);
  }

  private observer: IntersectionObserver | null = null;
  private lastRevealDelay: number | null = null;

  private initObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const options = [0, 150, 300].filter((d) => d !== this.lastRevealDelay);
            const delay = options[Math.floor(Math.random() * options.length)];
            this.lastRevealDelay = delay;
            setTimeout(() => {
              entry.target.classList.add('active');
            }, delay);
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
  }

  observeReveal(): void {
    if (!this.observer) {
      this.initObserver();
    }
    document.querySelectorAll('.reveal:not(.active)').forEach(el => {
      this.observer.observe(el);
    });
  }

  reveal(): void {
    this.observeReveal();
  }

  revealTimeout(): void {
    setTimeout(() => this.observeReveal(), 0);
  }

  sortItems(arr, property) {
    const sortedArr = arr.sort((a, b) => {
      const entityA = this.dataService.entityCache[a];
      const entityB = this.dataService.entityCache[b];
      if (entityA && entityB && entityA[property] && entityB[property]) {
        return (entityA[property][this.dataService.currentLanguage] ?? '').localeCompare(
          entityB[property][this.dataService.currentLanguage] ?? ''
        );
      }
      return 0;
    });

    return sortedArr;
  }
}
